import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginBottom: theme.spacing(2),
      padding: theme.spacing(2),
    },
    content: {
      marginBottom: theme.spacing(1),
    },
    rows: {
      margin: `0 -${theme.spacing(3)}`,
    },
    row: {
      marginTop: 0,
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),

      // padding: `${theme.spacing(1)} ${theme.spacing(4)} ${theme.spacing(4)}`,
      "&:first-of-type:not(:first-child)": {
        // marginTop: theme.spacing(3),
      },
      "&:nth-child(even)": {
        backgroundColor: theme.palette.grey[50],
        border: `1px solid ${theme.palette.grey[200]}`,
        borderWidth: "1px 0",
      },
    },
    actions: {
      bottom: 0,
      display: "flex",
      justifyContent: "flex-end",
      marginTop: theme.spacing(2),
      pointerEvents: "none",
      position: "sticky",
    },
    addButton: {
      pointerEvents: "initial",
    },
    dialogRoot: {
      maxWidth: "70vw",
      maxHeight: "70vh",
      minHeight: "50vh",
      width: "100%",
      [theme.breakpoints.up("lg")]: {
        maxWidth: 1000,
      },
      [theme.breakpoints.down("sm")]: {
        maxWidth: "98vw",
        [theme.breakpoints.down("md")]: {
          margin: theme.spacing(2),
        },
      },
    },
  })
);
